"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9084],{

/***/ 99084:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ victory_pie; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/victory-core/es/victory-util/helpers.js
var helpers = __webpack_require__(95302);
// EXTERNAL MODULE: ./node_modules/victory-core/es/victory-util/user-props.js
var user_props = __webpack_require__(80450);
// EXTERNAL MODULE: ./node_modules/victory-core/es/victory-util/prop-types.js
var victory_util_prop_types = __webpack_require__(99733);
// EXTERNAL MODULE: ./node_modules/victory-core/es/victory-label/victory-label.js + 2 modules
var victory_label = __webpack_require__(41248);
// EXTERNAL MODULE: ./node_modules/victory-core/es/victory-container/victory-container.js + 1 modules
var victory_container = __webpack_require__(3532);
// EXTERNAL MODULE: ./node_modules/victory-core/es/victory-theme/victory-theme.js + 2 modules
var victory_theme = __webpack_require__(6673);
// EXTERNAL MODULE: ./node_modules/victory-core/es/victory-util/data.js + 1 modules
var victory_util_data = __webpack_require__(26063);
// EXTERNAL MODULE: ./node_modules/victory-core/es/victory-util/add-events.js + 30 modules
var add_events = __webpack_require__(55527);
// EXTERNAL MODULE: ./node_modules/lodash/assign.js
var lodash_assign = __webpack_require__(28583);
var assign_default = /*#__PURE__*/__webpack_require__.n(lodash_assign);
// EXTERNAL MODULE: ./node_modules/lodash/isFunction.js
var isFunction = __webpack_require__(23560);
var isFunction_default = /*#__PURE__*/__webpack_require__.n(isFunction);
// EXTERNAL MODULE: ./node_modules/lodash/defaults.js
var defaults = __webpack_require__(91747);
var defaults_default = /*#__PURE__*/__webpack_require__.n(defaults);
// EXTERNAL MODULE: ./node_modules/victory-core/es/victory-util/common-props.js
var common_props = __webpack_require__(5734);
// EXTERNAL MODULE: ./node_modules/victory-core/es/victory-primitives/path.js
var path = __webpack_require__(5613);
// EXTERNAL MODULE: ./node_modules/d3-shape/src/arc.js
var arc = __webpack_require__(16348);
;// CONCATENATED MODULE: ./node_modules/victory-pie/es/slice.js




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var getPath = function (props) {
  var slice = props.slice,
      radius = props.radius,
      innerRadius = props.innerRadius,
      cornerRadius = props.cornerRadius;

  if (isFunction_default()(props.pathFunction)) {
    return props.pathFunction(slice);
  }

  var padAngle = helpers/* degreesToRadians */.Ht(props.padAngle);
  var startAngle = helpers/* degreesToRadians */.Ht(props.sliceStartAngle);
  var endAngle = helpers/* degreesToRadians */.Ht(props.sliceEndAngle);
  var pathFunction = arc/* default */.Z().cornerRadius(cornerRadius).outerRadius(radius).innerRadius(innerRadius || 0);
  return pathFunction(defaults_default()({
    startAngle: startAngle,
    endAngle: endAngle,
    padAngle: padAngle
  }, slice));
};

var evaluateProps = function (props) {
  /**
   * * Potential evaluated props of following must be evaluated in this order:
   * 1) `style`
   * 2) `radius`
   * 3) `innerRadius`
   *
   * Everything else does not have to be evaluated in a particular order:
   * `ariaLabel`
   * `id`
   * `cornerRadius`
   * `padAngle`
   * `sliceStartAngle`
   * `sliceEndAngle`
   * `tabIndex`
   */
  var style = helpers/* evaluateStyle */.F3(props.style, props);
  var radius = helpers/* evaluateProp */.xs(props.radius, assign_default()({}, props, {
    style: style
  }));
  var innerRadius = helpers/* evaluateProp */.xs(props.innerRadius, assign_default()({}, props, {
    style: style,
    radius: radius
  }));
  var ariaLabel = helpers/* evaluateProp */.xs(props.ariaLabel, props);
  var id = helpers/* evaluateProp */.xs(props.id, props);
  var cornerRadius = helpers/* evaluateProp */.xs(props.cornerRadius, props);
  var padAngle = helpers/* evaluateProp */.xs(props.padAngle, props);
  var sliceStartAngle = helpers/* evaluateProp */.xs(props.sliceStartAngle, props);
  var sliceEndAngle = helpers/* evaluateProp */.xs(props.sliceEndAngle, props);
  var tabIndex = helpers/* evaluateProp */.xs(props.tabIndex, props);
  return assign_default()({}, props, {
    ariaLabel: ariaLabel,
    style: style,
    radius: radius,
    innerRadius: innerRadius,
    id: id,
    cornerRadius: cornerRadius,
    padAngle: padAngle,
    sliceStartAngle: sliceStartAngle,
    sliceEndAngle: sliceEndAngle,
    tabIndex: tabIndex
  });
};

var Slice = function (props) {
  props = evaluateProps(props);
  var defaultTransform = props.origin ? "translate(".concat(props.origin.x, ", ").concat(props.origin.y, ")") : undefined;
  return /*#__PURE__*/react.cloneElement(props.pathComponent, _objectSpread(_objectSpread({}, props.events), {}, {
    "aria-label": props.ariaLabel,
    d: getPath(props),
    style: props.style,
    transform: props.transform || defaultTransform,
    className: props.className,
    role: props.role,
    shapeRendering: props.shapeRendering,
    clipPath: props.clipPath,
    tabIndex: props.tabIndex
  }));
};

Slice.propTypes = _objectSpread(_objectSpread({}, common_props/* CommonProps.primitiveProps */.l.primitiveProps), {}, {
  cornerRadius: prop_types_default().oneOfType([(prop_types_default()).number, (prop_types_default()).func]),
  datum: (prop_types_default()).object,
  innerRadius: prop_types_default().oneOfType([(prop_types_default()).number, (prop_types_default()).func]),
  padAngle: prop_types_default().oneOfType([(prop_types_default()).number, (prop_types_default()).func]),
  pathComponent: (prop_types_default()).element,
  pathFunction: (prop_types_default()).func,
  radius: prop_types_default().oneOfType([(prop_types_default()).number, (prop_types_default()).func]),
  slice: (prop_types_default()).object,
  sliceEndAngle: prop_types_default().oneOfType([(prop_types_default()).number, (prop_types_default()).func]),
  sliceStartAngle: prop_types_default().oneOfType([(prop_types_default()).number, (prop_types_default()).func])
});
Slice.defaultProps = {
  pathComponent: /*#__PURE__*/react.createElement(path/* Path */.y, null),
  role: "presentation",
  shapeRendering: "auto"
};
/* harmony default export */ var slice = (Slice);
// EXTERNAL MODULE: ./node_modules/lodash/isNil.js
var isNil = __webpack_require__(14293);
var isNil_default = /*#__PURE__*/__webpack_require__.n(isNil);
// EXTERNAL MODULE: ./node_modules/lodash/isPlainObject.js
var isPlainObject = __webpack_require__(68630);
var isPlainObject_default = /*#__PURE__*/__webpack_require__.n(isPlainObject);
// EXTERNAL MODULE: ./node_modules/d3-shape/src/pie.js + 2 modules
var pie = __webpack_require__(29025);
// EXTERNAL MODULE: ./node_modules/victory-core/es/victory-util/style.js
var victory_util_style = __webpack_require__(38586);
;// CONCATENATED MODULE: ./node_modules/victory-pie/es/helper-methods.js








var checkForValidText = function (text) {
  if (text === undefined || text === null || isFunction_default()(text)) {
    return text;
  }

  return "".concat(text);
};

var getColor = function (style, colors, index) {
  if (style && style.data && style.data.fill) {
    return style.data.fill;
  }

  return colors && colors[index % colors.length];
};

var getRadius = function (props, padding) {
  if (typeof props.radius === "number") {
    return props.radius;
  }

  return Math.min(props.width - padding.left - padding.right, props.height - padding.top - padding.bottom) / 2;
};

var getOrigin = function (props, padding) {
  var width = props.width,
      height = props.height;
  var origin = isPlainObject_default()(props.origin) ? props.origin : {};
  return {
    x: origin.x !== undefined ? origin.x : (padding.left - padding.right + width) / 2,
    y: origin.y !== undefined ? origin.y : (padding.top - padding.bottom + height) / 2
  };
};

var getSlices = function (props, data) {
  var padAngle = isFunction_default()(props.padAngle) ? 0 : props.padAngle;
  var layoutFunction = pie/* default */.Z().sort(null).startAngle(helpers/* degreesToRadians */.Ht(props.startAngle)).endAngle(helpers/* degreesToRadians */.Ht(props.endAngle)).padAngle(helpers/* degreesToRadians */.Ht(padAngle)).value(function (datum) {
    return datum._y;
  });
  return layoutFunction(data);
};

var getCalculatedValues = function (props) {
  var colorScale = props.colorScale;
  var styleObject = helpers/* getDefaultStyles */.Lo(props, "pie");
  var style = helpers/* getStyles */.Wi(props.style, styleObject, "auto", "100%");
  var colors = Array.isArray(colorScale) ? colorScale : victory_util_style/* getColorScale */.p(colorScale);
  var padding = helpers/* getPadding */.tQ(props);
  var defaultRadius = getRadius(props, padding);
  var origin = getOrigin(props, padding);
  var data = victory_util_data/* getData */.Yu(props);
  var slices = getSlices(props, data);
  return assign_default()({}, props, {
    style: style,
    colors: colors,
    padding: padding,
    defaultRadius: defaultRadius,
    data: data,
    slices: slices,
    origin: origin
  });
};

var getSliceStyle = function (index, calculatedValues) {
  var style = calculatedValues.style,
      colors = calculatedValues.colors;
  var fill = getColor(style, colors, index);
  return assign_default()({
    fill: fill
  }, style.data);
};

var getLabelText = function (props, datum, index) {
  var text;

  if (datum.label) {
    text = datum.label;
  } else if (Array.isArray(props.labels)) {
    text = props.labels[index];
  } else {
    text = isFunction_default()(props.labels) ? props.labels : datum.xName || datum._x;
  }

  return checkForValidText(text);
};

var getLabelArc = function (radius, labelRadius, style) {
  var padding = style && style.padding || 0;
  var arcRadius = labelRadius || radius + padding;
  return arc/* default */.Z().outerRadius(arcRadius).innerRadius(arcRadius);
};

var getLabelPosition = function (arc, slice, position) {
  var construct = {
    startAngle: position === "startAngle" ? slice.startAngle : slice.endAngle,
    endAngle: position === "endAngle" ? slice.endAngle : slice.startAngle
  };

  var clonedArc = assign_default()({}, slice, construct);

  return arc.centroid(clonedArc);
};

var getLabelOrientation = function (degree, labelPlacement) {
  if (labelPlacement === "perpendicular") {
    return degree > 90 && degree < 270 ? "bottom" : "top";
  } else if (labelPlacement === "parallel") {
    return degree >= 0 && degree <= 180 ? "right" : "left";
  }

  if (degree < 45 || degree > 315) {
    return "top";
  } else if (degree >= 45 && degree < 135) {
    return "right";
  } else if (degree >= 135 && degree < 225) {
    return "bottom";
  }

  return "left";
};

var getTextAnchor = function (orientation) {
  if (orientation === "top" || orientation === "bottom") {
    return "middle";
  }

  return orientation === "right" ? "start" : "end";
};

var getVerticalAnchor = function (orientation) {
  if (orientation === "left" || orientation === "right") {
    return "middle";
  }

  return orientation === "bottom" ? "start" : "end";
};

var getBaseLabelAngle = function (slice, labelPosition, labelStyle) {
  var baseAngle = 0;

  if (labelPosition.angle !== undefined) {
    baseAngle = labelStyle.angle;
  } else if (labelPosition === "centroid") {
    baseAngle = helpers/* radiansToDegrees */.vi((slice.startAngle + slice.endAngle) / 2);
  } else {
    baseAngle = labelPosition === "startAngle" ? helpers/* radiansToDegrees */.vi(slice.startAngle) : helpers/* radiansToDegrees */.vi(slice.endAngle);
  }

  var positiveAngle = baseAngle < 0 ? 360 - baseAngle : baseAngle;
  return positiveAngle % 360;
};

var getLabelAngle = function (baseAngle, labelPlacement) {
  if (labelPlacement === "vertical") {
    return 0;
  }

  if (labelPlacement === "parallel") {
    return baseAngle > 180 && baseAngle < 360 ? baseAngle + 90 : baseAngle - 90;
  }

  return baseAngle > 90 && baseAngle < 270 ? baseAngle - 180 : baseAngle;
};

var getLabelProps = function (text, dataProps, calculatedValues) {
  var index = dataProps.index,
      datum = dataProps.datum,
      data = dataProps.data,
      slice = dataProps.slice,
      labelComponent = dataProps.labelComponent,
      theme = dataProps.theme;
  var style = calculatedValues.style,
      defaultRadius = calculatedValues.defaultRadius,
      origin = calculatedValues.origin,
      width = calculatedValues.width,
      height = calculatedValues.height;
  var labelRadius = helpers/* evaluateProp */.xs(calculatedValues.labelRadius, assign_default()({
    text: text
  }, dataProps));
  var labelPosition = helpers/* evaluateProp */.xs(calculatedValues.labelPosition, assign_default()({
    text: text
  }, dataProps)) || "centroid";
  var labelPlacement = helpers/* evaluateProp */.xs(calculatedValues.labelPlacement, assign_default()({
    text: text
  }, dataProps)) || "vertical";

  var labelStyle = assign_default()({
    padding: 0
  }, style.labels);

  var evaluatedStyle = helpers/* evaluateStyle */.F3(labelStyle, assign_default()({
    labelRadius: labelRadius,
    text: text
  }, dataProps));
  var labelArc = getLabelArc(defaultRadius, labelRadius, evaluatedStyle);
  var position = getLabelPosition(labelArc, slice, labelPosition);
  var baseAngle = getBaseLabelAngle(slice, labelPosition, labelStyle);
  var labelAngle = getLabelAngle(baseAngle, labelPlacement);
  var orientation = getLabelOrientation(baseAngle, labelPlacement);
  var textAnchor = labelStyle.textAnchor || getTextAnchor(orientation);
  var verticalAnchor = labelStyle.verticalAnchor || getVerticalAnchor(orientation);
  var labelProps = {
    width: width,
    height: height,
    index: index,
    datum: datum,
    data: data,
    slice: slice,
    orientation: orientation,
    text: text,
    style: labelStyle,
    x: Math.round(position[0]) + origin.x,
    y: Math.round(position[1]) + origin.y,
    textAnchor: textAnchor,
    verticalAnchor: verticalAnchor,
    angle: labelAngle
  };

  if (!helpers/* isTooltip */.ij(labelComponent)) {
    return labelProps;
  }

  var tooltipTheme = theme && theme.tooltip || {};
  return defaults_default()({}, labelProps, helpers/* omit */.CE(tooltipTheme, ["style"]));
};

var getBaseProps = function (props, fallbackProps) {
  props = helpers/* modifyProps */.TY(props, fallbackProps, "pie");
  var calculatedValues = getCalculatedValues(props);
  var slices = calculatedValues.slices,
      style = calculatedValues.style,
      data = calculatedValues.data,
      origin = calculatedValues.origin,
      defaultRadius = calculatedValues.defaultRadius,
      labels = calculatedValues.labels,
      events = calculatedValues.events,
      sharedEvents = calculatedValues.sharedEvents,
      height = calculatedValues.height,
      width = calculatedValues.width,
      standalone = calculatedValues.standalone,
      name = calculatedValues.name,
      innerRadius = calculatedValues.innerRadius,
      cornerRadius = calculatedValues.cornerRadius,
      padAngle = calculatedValues.padAngle,
      disableInlineStyles = calculatedValues.disableInlineStyles;
  var radius = props.radius || defaultRadius;
  var initialChildProps = {
    parent: {
      standalone: standalone,
      height: height,
      width: width,
      slices: slices,
      name: name,
      style: style.parent
    }
  };
  return slices.reduce(function (childProps, slice, index) {
    var datum = defaults_default()({}, data[index], {
      startAngle: helpers/* radiansToDegrees */.vi(slice.startAngle),
      endAngle: helpers/* radiansToDegrees */.vi(slice.endAngle),
      padAngle: helpers/* radiansToDegrees */.vi(slice.padAngle)
    });

    var eventKey = !isNil_default()(datum.eventKey) ? datum.eventKey : index;
    var dataProps = {
      index: index,
      slice: slice,
      datum: datum,
      data: data,
      origin: origin,
      innerRadius: innerRadius,
      radius: radius,
      cornerRadius: cornerRadius,
      padAngle: padAngle,
      style: disableInlineStyles ? {} : getSliceStyle(index, calculatedValues),
      disableInlineStyles: disableInlineStyles
    };
    childProps[eventKey] = {
      data: dataProps
    };
    var text = getLabelText(props, datum, index);

    if (text !== undefined && text !== null || labels && (events || sharedEvents)) {
      var evaluatedText = helpers/* evaluateProp */.xs(text, dataProps);
      childProps[eventKey].labels = getLabelProps(evaluatedText, assign_default()({}, props, dataProps), calculatedValues);
    }

    return childProps;
  }, initialChildProps);
};
;// CONCATENATED MODULE: ./node_modules/victory-pie/es/victory-pie.js
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* eslint no-magic-numbers: ["error", { "ignore": [-1, 0, 1, 2] }]*/





var fallbackProps = {
  endAngle: 360,
  height: 400,
  innerRadius: 0,
  cornerRadius: 0,
  padAngle: 0,
  padding: 30,
  width: 400,
  startAngle: 0,
  colorScale: ["#ffffff", "#f0f0f0", "#d9d9d9", "#bdbdbd", "#969696", "#737373", "#525252", "#252525", "#000000"],
  labelPosition: "centroid"
};

var VictoryPie = /*#__PURE__*/function (_React$Component) {
  _inherits(VictoryPie, _React$Component);

  var _super = _createSuper(VictoryPie);

  function VictoryPie() {
    _classCallCheck(this, VictoryPie);

    return _super.apply(this, arguments);
  }

  _createClass(VictoryPie, [{
    key: "shouldAnimate",
    value: // Overridden in victory-native
    function shouldAnimate() {
      return Boolean(this.props.animate);
    }
  }, {
    key: "render",
    value: function render() {
      var animationWhitelist = VictoryPie.animationWhitelist,
          role = VictoryPie.role;
      var props = helpers/* modifyProps */.TY(this.props, fallbackProps, role);

      if (this.shouldAnimate()) {
        return this.animateComponent(props, animationWhitelist);
      }

      var children = this.renderData(props);
      var component = props.standalone ? this.renderContainer(props.containerComponent, children) : children;
      return user_props/* withSafeUserProps */.h(component, props);
    }
  }]);

  return VictoryPie;
}(react.Component);

VictoryPie.animationWhitelist = ["data", "endAngle", "height", "innerRadius", "cornerRadius", "padAngle", "padding", "colorScale", "startAngle", "style", "width"];
VictoryPie.displayName = "VictoryPie";
VictoryPie.role = "pie";
VictoryPie.defaultTransitions = {
  onExit: {
    duration: 500,
    before: function () {
      return {
        _y: 0,
        label: " "
      };
    }
  },
  onEnter: {
    duration: 500,
    before: function () {
      return {
        _y: 0,
        label: " "
      };
    },
    after: function (datum) {
      return {
        y_: datum._y,
        label: datum.label
      };
    }
  }
};
VictoryPie.propTypes = {
  animate: prop_types_default().oneOfType([(prop_types_default()).bool, (prop_types_default()).object]),
  colorScale: prop_types_default().oneOfType([prop_types_default().arrayOf((prop_types_default()).string), prop_types_default().oneOf(["grayscale", "qualitative", "heatmap", "warm", "cool", "red", "green", "blue"])]),
  containerComponent: (prop_types_default()).element,
  cornerRadius: prop_types_default().oneOfType([victory_util_prop_types/* nonNegative */.A7, (prop_types_default()).func]),
  data: (prop_types_default()).array,
  dataComponent: (prop_types_default()).element,
  disableInlineStyes: (prop_types_default()).bool,
  endAngle: (prop_types_default()).number,
  eventKey: prop_types_default().oneOfType([(prop_types_default()).func, victory_util_prop_types/* allOfType */.BO([victory_util_prop_types/* integer */._L, victory_util_prop_types/* nonNegative */.A7]), (prop_types_default()).string]),
  events: prop_types_default().arrayOf(prop_types_default().shape({
    target: prop_types_default().oneOf(["data", "labels", "parent"]),
    eventKey: prop_types_default().oneOfType([(prop_types_default()).array, (prop_types_default()).func, victory_util_prop_types/* allOfType */.BO([victory_util_prop_types/* integer */._L, victory_util_prop_types/* nonNegative */.A7]), (prop_types_default()).string]),
    eventHandlers: (prop_types_default()).object
  })),
  externalEventMutations: prop_types_default().arrayOf(prop_types_default().shape({
    callback: (prop_types_default()).func,
    childName: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).array]),
    eventKey: prop_types_default().oneOfType([(prop_types_default()).array, victory_util_prop_types/* allOfType */.BO([victory_util_prop_types/* integer */._L, victory_util_prop_types/* nonNegative */.A7]), (prop_types_default()).string]),
    mutation: (prop_types_default()).func,
    target: prop_types_default().oneOfType([(prop_types_default()).string, (prop_types_default()).array])
  })),
  groupComponent: (prop_types_default()).element,
  height: victory_util_prop_types/* nonNegative */.A7,
  innerRadius: prop_types_default().oneOfType([victory_util_prop_types/* nonNegative */.A7, (prop_types_default()).func]),
  labelComponent: (prop_types_default()).element,
  labelPlacement: prop_types_default().oneOfType([(prop_types_default()).func, prop_types_default().oneOf(["parallel", "perpendicular", "vertical"])]),
  labelPosition: prop_types_default().oneOfType([(prop_types_default()).func, prop_types_default().oneOf(["startAngle", "centroid", "endAngle"])]),
  labelRadius: prop_types_default().oneOfType([victory_util_prop_types/* nonNegative */.A7, (prop_types_default()).func]),
  labels: prop_types_default().oneOfType([(prop_types_default()).func, (prop_types_default()).array]),
  name: (prop_types_default()).string,
  origin: prop_types_default().shape({
    x: victory_util_prop_types/* nonNegative */.A7,
    y: victory_util_prop_types/* nonNegative */.A7
  }),
  padAngle: prop_types_default().oneOfType([victory_util_prop_types/* nonNegative */.A7, (prop_types_default()).func]),
  padding: prop_types_default().oneOfType([(prop_types_default()).number, prop_types_default().shape({
    top: (prop_types_default()).number,
    bottom: (prop_types_default()).number,
    left: (prop_types_default()).number,
    right: (prop_types_default()).number
  })]),
  radius: prop_types_default().oneOfType([victory_util_prop_types/* nonNegative */.A7, (prop_types_default()).func]),
  sharedEvents: prop_types_default().shape({
    events: (prop_types_default()).array,
    getEventState: (prop_types_default()).func
  }),
  sortKey: prop_types_default().oneOfType([(prop_types_default()).func, victory_util_prop_types/* allOfType */.BO([victory_util_prop_types/* integer */._L, victory_util_prop_types/* nonNegative */.A7]), (prop_types_default()).string, prop_types_default().arrayOf((prop_types_default()).string)]),
  sortOrder: prop_types_default().oneOf(["ascending", "descending"]),
  standalone: (prop_types_default()).bool,
  startAngle: (prop_types_default()).number,
  style: prop_types_default().shape({
    parent: (prop_types_default()).object,
    data: (prop_types_default()).object,
    labels: (prop_types_default()).object
  }),
  theme: (prop_types_default()).object,
  width: victory_util_prop_types/* nonNegative */.A7,
  x: prop_types_default().oneOfType([(prop_types_default()).func, victory_util_prop_types/* allOfType */.BO([victory_util_prop_types/* integer */._L, victory_util_prop_types/* nonNegative */.A7]), (prop_types_default()).string, prop_types_default().arrayOf((prop_types_default()).string)]),
  y: prop_types_default().oneOfType([(prop_types_default()).func, victory_util_prop_types/* allOfType */.BO([victory_util_prop_types/* integer */._L, victory_util_prop_types/* nonNegative */.A7]), (prop_types_default()).string, prop_types_default().arrayOf((prop_types_default()).string)])
};
VictoryPie.defaultProps = {
  data: [{
    x: "A",
    y: 1
  }, {
    x: "B",
    y: 2
  }, {
    x: "C",
    y: 3
  }, {
    x: "D",
    y: 1
  }, {
    x: "E",
    y: 2
  }],
  standalone: true,
  dataComponent: /*#__PURE__*/react.createElement(slice, null),
  labelComponent: /*#__PURE__*/react.createElement(victory_label/* VictoryLabel */.X, null),
  containerComponent: /*#__PURE__*/react.createElement(victory_container/* VictoryContainer */._, null),
  groupComponent: /*#__PURE__*/react.createElement("g", null),
  sortOrder: "ascending",
  theme: victory_theme/* VictoryTheme.grayscale */.J.grayscale
};

VictoryPie.getBaseProps = function (props) {
  return getBaseProps(props, fallbackProps);
};

VictoryPie.getData = victory_util_data/* getData */.Yu;
VictoryPie.expectedComponents = ["dataComponent", "labelComponent", "groupComponent", "containerComponent"];
/* harmony default export */ var victory_pie = ((0,add_events/* addEvents */.o)(VictoryPie));

/***/ })

}]);